module.exports = {
      id: "icon-appstore-usage",
      viewBox: "0 0 189.408 63.551",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-appstore",
      toString: function () {
        return this.url;
      }
    }